import { useCallback, useEffect } from "react"

const useMentionableMenuKeyboardNavigation = ({
  clearMentionables, decrementHighlightedIndex, incrementHighlightedIndex, mentionHighlighted,
}) => {
  const handleKeyPress = useCallback((event) => {
    const { key } = event

    switch (key) {
    case "ArrowDown":
      incrementHighlightedIndex()
      event.preventDefault()
      break
    case "ArrowUp":
      decrementHighlightedIndex()
      event.preventDefault()
      break
    case "Enter":
    case "Tab":
      mentionHighlighted()
      event.preventDefault()
      break
    case "Escape":
      clearMentionables()
      event.preventDefault()
      break
    default:
    }
  }, [decrementHighlightedIndex, incrementHighlightedIndex, mentionHighlighted])

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress, true)
    return () => document.removeEventListener("keydown", handleKeyPress, true)
  }, [handleKeyPress])
}

export default useMentionableMenuKeyboardNavigation
